import { render } from "./LeadsForApproval.vue?vue&type=template&id=aaaf6c14&scoped=true"
import script from "./LeadsForApproval.vue?vue&type=script&lang=js"
export * from "./LeadsForApproval.vue?vue&type=script&lang=js"

import "./LeadsForApproval.vue?vue&type=style&index=0&id=aaaf6c14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaaf6c14"]])

export default __exports__